import React from "react";

export const SubTitle = ({ title, position }) => {
  return (
    <div className={position}>
      <h4 className="sub-title-text">{title}</h4>
      <svg
        className="sub-title"
        width="95"
        height="30"
        viewBox="0 0 95 10"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 8l11.54-6 11.538 6 11.54-6 11.538 6 11.538-6 11.54 6L81.77 2 94 8"
          stroke-width="3"
          stroke="#6CC139"
          fill="none"
          fill-rule="evenodd"
        ></path>
      </svg>{" "}
    </div>
  );
};
